import React  from 'react';
import { ReferenceField, TextField, BooleanField } from "react-admin";
import { ListGuesser } from "@api-platform/admin";

const CollectionList = (props) => (
    <ListGuesser {...props}>
      <TextField source="name" />
      <TextField source="slug" />
      <TextField source="title" />
      <ReferenceField label="File" source="file" reference="files">
        <TextField source="title" />
      </ReferenceField>
      <BooleanField source="enabled" />
    </ListGuesser>
  );

export default CollectionList;